import { Component, Input, ViewChild } from '@angular/core';
import { CdkPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import { ILink } from 'src/app/interfaces/ilink';
import { UserService } from 'src/app/services/general/user.service';
import { ControlService } from 'src/app/pages/learner/call/library/control.service';
import { animations } from './navbar.animations';
import { environment } from 'src/environments/environment';
import { SupportModalComponent } from '../../modals/support-modal/support-modal.component';
import { take, filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { CallStoreService } from 'src/app/pages/learner/call/library/call-store/call-store.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false,
  animations: animations,
})
export class NavbarComponent {
  @Input() links: ILink[] = [];
  @Input() loginScreen: boolean = false;
  @Input() isQcAdmin: boolean = false;
  @ViewChild('supportModal', { static: true, read: CdkPortalOutlet })
  supportModalPortalOutlet!: CdkPortalOutlet;
  isDropdownMenuOpen: boolean = false;
  isSupportOpen: boolean = false;
  userFirstName: string = '';
  userLastName: string = '';
  userNameInitials: string = '';
  componentPortal: ComponentPortal<SupportModalComponent> | null = null;
  currentUrl: string = '';
  hideNavbar: boolean = false;

  constructor(
    private userService: UserService,
    public controlService: ControlService,
    private router: Router,
    private callStore: CallStoreService
  ) {}

  ngOnInit(): void {
    this.validateRoute();
    // ---- Setting User's name and initials for NavBar's profile
    const storedUserFirstName: string | null =
      localStorage.getItem('user_first_name');
    const storedUserLastName: string | null =
      localStorage.getItem('user_last_name');

    // We check if strings are not Empty and that they don't contain only whitespaces
    if (storedUserFirstName && storedUserFirstName.trim()) {
      this.userFirstName = storedUserFirstName;
      this.userNameInitials = Array.from(this.userFirstName.trimStart())[0];
    } else {
      console.warn('Empty/Null or whitespace only User firstName');
    }

    if (storedUserLastName && storedUserLastName.trim()) {
      this.userLastName = storedUserLastName;
      this.userNameInitials =
        this.userNameInitials + Array.from(this.userLastName.trimStart())[0];
    } else {
      console.warn('Empty/Null or whitespace only User lastName');
    }
  }

  toggleDropdown = () => {
    this.isDropdownMenuOpen = !this.isDropdownMenuOpen;
  };

  openModal() {
    if (!this.supportModalPortalOutlet.hasAttached()) {
      if (this.componentPortal === null) {
        this.componentPortal = new ComponentPortal(SupportModalComponent);
      }

      let attachedComponentRef =
        this.supportModalPortalOutlet.attachComponentPortal(
          this.componentPortal
        );
      this.isSupportOpen = true;
      const isPaused = this.callStore.getIsPaused();
      if (this.isSupportOpen && !isPaused) {
        this.controlService.pauseSimulation();
      }
      // Handling closeModal
      attachedComponentRef.instance.closeModalEvent
        .pipe(take(1))
        .subscribe(() => {
          this.isSupportOpen = false;
          this.supportModalPortalOutlet.detach();
          // not paused
          if (!isPaused) {
            this.controlService.togglePause();
          }
        });
      if (!this.isSupportOpen && isPaused) {
        this.controlService.unpauseSimulation();
      }
    }
  }

  logout = () => {
    this.userService.logoutRequest().subscribe((response) => {
      console.log(response);
    });
  };

  navigate(url: string): void {
    window.location.assign(url);
  }

  goToAdminPortal() {
    const adminPortalUrl = this.userService.getAdminPortalUrl();
    localStorage.setItem('returnUrl', encodeURIComponent(adminPortalUrl));
    this.navigate(adminPortalUrl);
  }

  validateRoute(): void {
    // Get the current URL on page load
    this.currentUrl = this.router.url;
    this.hideNavbar = this.currentUrl.includes('/call');

    // Subscribe to route changes and update currentUrl when the URL changes
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: any) => {
        this.currentUrl = event.url;
        this.hideNavbar = this.currentUrl.includes('/call');
      });
  }
}
